import { FormulaTokenTipoEnum } from '@shared/enums/formula/formula-token-tipo.enum';
import { TipoOrigemVariavelEnum } from '@shared/enums/formula/tipo-origem-variavel.enum';
import { VariavelStruct } from '@shared/services/structs/formula/variavel.struct';
import { FormulaExpressaoToken } from './formula-expressao-token';

const OPERADORES_ARITMETICOS = ['+', '-', '*', '/'];
const OPERADORES_COMPARACAO = ['>', '<', '>=', '<=', '=', '<>'];
const OPERADORES_LOGICOS = ['e', 'ou'];

/** Classes semânticas dos badges do módulo de fórmulas. */
export const FORMULA_BADGE_CLASSES = {
    variavelSistema: 'badge-formula-variavel-sistema',
    variavelXml: 'badge-formula-variavel-xml',
    variavelParametro: 'badge-formula-variavel-parametro',
    constante: 'badge-formula-constante',
    operadorAritmetico: 'badge-formula-operador-aritmetico',
    operadorAgrupamento: 'badge-formula-operador-agrupamento',
    operadorComparacao: 'badge-formula-operador-comparacao',
    operadorLogico: 'badge-formula-operador-logico',
    separador: 'badge-formula-separador',
    modelo: 'badge-formula-modelo',
    padraoSistema: 'badge-modelo-padrao-sistema',
    padraoEmpresa: 'badge-modelo-padrao-empresa',
    personalizada: 'badge-formula-personalizada',
    quantidade: 'badge-formula-quantidade',
} as const;

/** A origem define a cor; fórmula aplicável e agrupamento são características independentes. */
export function classeBadgeVariavel(variavel: VariavelStruct | null | undefined): string {
    const origem = variavel?.tipoOrigemVariavel ?? TipoOrigemVariavelEnum.TagXml;
    if (origem === TipoOrigemVariavelEnum.Sistema) return FORMULA_BADGE_CLASSES.variavelSistema;
    if (origem === TipoOrigemVariavelEnum.Parametro) return FORMULA_BADGE_CLASSES.variavelParametro;
    return FORMULA_BADGE_CLASSES.variavelXml;
}

export function isVariavelParametro(variavel: VariavelStruct | null | undefined): boolean {
    return variavel?.tipoOrigemVariavel === TipoOrigemVariavelEnum.Parametro;
}

/** Resolve a classe visual de um token que não pertença à estrutura de uma função. */
export function classeBadgeTokenFormula(token: FormulaExpressaoToken): string {
    if (token.tipo === FormulaTokenTipoEnum.Variavel) return FORMULA_BADGE_CLASSES.variavelXml;
    if (token.tipo === FormulaTokenTipoEnum.Funcao) return classeBadgeFuncao(token.valor, 0);
    if (token.tipo === FormulaTokenTipoEnum.Parentese) return FORMULA_BADGE_CLASSES.operadorAgrupamento;
    if (token.tipo === FormulaTokenTipoEnum.Constante) return FORMULA_BADGE_CLASSES.constante;
    if (token.tipo === FormulaTokenTipoEnum.Separador) return FORMULA_BADGE_CLASSES.separador;

    const operador = token.valor.trim().toLowerCase();
    if (OPERADORES_COMPARACAO.includes(operador)) return FORMULA_BADGE_CLASSES.operadorComparacao;
    if (OPERADORES_LOGICOS.includes(operador)) return FORMULA_BADGE_CLASSES.operadorLogico;
    if (OPERADORES_ARITMETICOS.includes(operador)) return FORMULA_BADGE_CLASSES.operadorAritmetico;
    return FORMULA_BADGE_CLASSES.operadorAritmetico;
}

/** Classe visual da função. O nível reinicia a cada três aninhamentos. */
export function classeBadgeFuncao(nome: string, nivel: number): string {
    const funcao = nome.replace('@', '').toLowerCase();
    const nomePermitido = ['se', 'soma', 'rateio'].includes(funcao) ? funcao : 'se';
    return `badge-${nomePermitido}-${Math.abs(nivel) % 3}`;
}
